import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { updateProduct } from './state/product_actions_creator';
import { ProductState, cloneState } from './state/product_state';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { WindowService } from '../../shared/services/window.service';
import { REDCRSS_EVENTS } from '../../shared/services/constants/redcross_evemts';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({
  selector: 'yi-platform',
  template: require('./product.component.html'),
  styles: [require('./product.component.scss')]
})
export class ProductComponent implements OnInit {

  popoverPlacement = this.windowService.isNarrowWindow() ? 'top' : 'right';
  @ViewChild('platformForm') platformForm: NgForm;
  @ViewChild('invalidWebsitePop') invalidWebsitePop: PopoverDirective;
  @ViewChild('invalidPlatformPop') invalidPlatformPop: PopoverDirective;
  state: ProductState;

  constructor(
    private store: Store<ProductState>,
    private redCrossService: AnalyticsTrackingProvider,
    private windowService: WindowService
  ) {
    this.store.subscribe((data: ProductState) => {
      this.state = cloneState(data);
    });
  }

  ngOnInit() {
    this.redCrossService.page(REDCRSS_EVENTS.VIEWED_B2B_PAGE, {pageCategory: 'Home'});
  }

  onSubmit(product) {
    this.store.dispatch(updateProduct({product}));
    this.redCrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'Product',
      product_category: product
    });
  }
}
